import {
  colorTypes,
  getBrandingColor,
  getBrandingStyleOverride,
  styleOverrides
} from "src/branding";
import styled, { css } from "styled-components";

const borderHeight = 1;

const mobileBreakpoint = `${400}px`;
const medimBreakpoint = 800;

const borderColor = getBrandingColor(colorTypes.statisticsTableBorder);

export const StyledTable = styled.table`
  position: relative;
  border-collapse: separate;
  border-spacing: 0;
  /*Edge 12-18 specific
    For some reason edge displays the borders as double width than otehr browsers
    */
  @supports (-ms-ime-align: auto) {
    border-collapse: collapse;
  }

  th,
  td {
    border: ${borderHeight}px solid ${borderColor};
    font-weight: normal;
    background: white;
  }

  tbody tr:hover th {
    ${({noHighlightRowOnHover}) => !noHighlightRowOnHover && css`
        background: ${getBrandingColor(colorTypes.statisticsHoverTableRowBg)};
      `}
  }
  tbody tr:hover td {
    ${({noHighlightRowOnHover}) => !noHighlightRowOnHover && css`
        background: ${getBrandingColor(colorTypes.statisticsHoverTableRowBg)};
      `}
  }

  th,
  td {
    padding: 0.32em;
    padding-right: 0.5em;
  }

  td {
    text-align: right;
  }
  th {
    text-align: left;
  }

  th[name="header"],
  th[name="mainHeader"] {
    background: ${getBrandingColor(colorTypes.statisticsTableHeaderCellBg)};
    color: ${getBrandingColor(colorTypes.statisticsTableHeaderCellColor)};
  }

  th[name="mainHeader"] {
    vertical-align: bottom;
  }

  th[name="subHeader"],
  th[name="header"],
  th[name="mainHeader"] {
    border-bottom: none;
    box-shadow: -1px 1px ${borderColor};
  }

  th[name="subHeader"],
  th[name="diseaseName"] {
    background: white;
  }

  @keyframes slide-down {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.9;
    }
  }

  /*There are som artifacts when starting to scroll on sticky headers om Edge,
  The solution is to mark the header as non-sticky for default and when the user
  scrolls, we make it sticky. To make up for eventual delay from detecting scroll and applying sticky, we
  play an animation
  */

  thead {
    @supports (-ms-ime-align: auto) {
      ${({ hasScrolledTop }) =>
        hasScrolledTop
          ? css`
              animation: slide-down 0.7s;
            `
          : ""}
    }
  }

  /*Sticky header and sub-header*/
  thead tr:first-child th {
    @supports not (-ms-ime-align: auto) {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
    }
    @supports (-ms-ime-align: auto) {
      ${({ hasScrolledTop }) =>
        hasScrolledTop
          ? css`
              position: -webkit-sticky;
              position: sticky;
              top: 0;
            `
          : ""}
    }

    /*Edge 12-18 specific
    Display the border as outline instead
    */
    @supports (-ms-ime-align: auto) {
      outline: 1px solid ${borderColor};
    }
  }
  thead tr:nth-child(2) th {
    @supports not (-ms-ime-align: auto) {
      position: -webkit-sticky;
      position: sticky;

      top: ${({ heightTopHeader }) =>
        heightTopHeader ? `${heightTopHeader}px` : "1.8em"};
    }

    @supports (-ms-ime-align: auto) {
      ${({ hasScrolledTop }) =>
        hasScrolledTop
          ? css`
              position: -webkit-sticky;
              position: sticky;

              top: ${({ heightTopHeader }) =>
                heightTopHeader ? `${heightTopHeader}px` : "1.8em"};
            `
          : ""}
    }

    /*Edge 12-18 specific
    Display the border as outline instead
    */
    @supports (-ms-ime-align: auto) {
      ${({ hasScrolledTop }) =>
        hasScrolledTop
          ? css`
              outline: 1px solid ${borderColor};
              border: none !important;
            `
          : ""}
    }
  }

  tbody th {
    border-right: 1px solid ${borderColor};
  }

  /*Make first column in body sticky*/
  tbody th {
    position: -webkit-sticky; /* for Safari */
    position: sticky;

    /*Edge 12-18 specific, since devices running edge most likely will be in desktop view, this is not
    that relevant and position sticky creates issues with border
    */
    @supports (-ms-ime-align: auto) {
      position: unset;
    }

    left: 0;
    border-right: 1px solid ${borderColor};
    background-clip: padding-box;

    /*To indicate that this is a fixed header*/
    ${({ hasScrolledLeft }) => (hasScrolledLeft ? css`` : "")}
  }

  th {
    padding-left: 1em;
    padding-right: 2.5em;
  }

  th[name="mainHeader"] {
    /*Sticky on the left*/
    left: 0;
    z-index: 2;
    font-size: 1.05em;

    ${getBrandingStyleOverride(styleOverrides.statisticsTableDiseseNameHeader)};
  }

  th[name="mainHeader"] {
    border-right: none;
  }

  th[name="header"] {
    border-left: none;
    box-shadow: none;
  }

  th[name="header"]:not(:last-child) {
    border-right: none;
  }

  @media screen and (max-width: ${mobileBreakpoint}) {
    th,
    td {
      padding-left: 1em;
      padding-right: 1em;
    }
  }
`;
